import React from 'react'

const Location = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask
        id="mask0_2791_62014"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2791_62014)">
        <path
          d="M10.95 12.925C11.0833 12.925 11.2083 12.904 11.325 12.862C11.4417 12.8207 11.55 12.75 11.65 12.65L15.2 9.1C15.3833 8.91667 15.475 8.68333 15.475 8.4C15.475 8.11667 15.3833 7.875 15.2 7.675C15 7.49167 14.7583 7.4 14.475 7.4C14.1917 7.4 13.9583 7.49167 13.775 7.675L10.95 10.5L10.25 9.8C10.0667 9.61667 9.83333 9.525 9.55 9.525C9.26667 9.525 9.03333 9.61667 8.85 9.8C8.65 10 8.55 10.2417 8.55 10.525C8.55 10.8083 8.65 11.0417 8.85 11.225L10.25 12.65C10.35 12.75 10.4583 12.8207 10.575 12.862C10.6917 12.904 10.8167 12.925 10.95 12.925ZM12 21.625C11.8667 21.625 11.7333 21.6 11.6 21.55C11.4667 21.5 11.35 21.4333 11.25 21.35C8.81667 19.2 7 17.2043 5.8 15.363C4.6 13.521 4 11.8 4 10.2C4 7.7 4.80433 5.70833 6.413 4.225C8.021 2.74167 9.88333 2 12 2C14.1167 2 15.979 2.74167 17.587 4.225C19.1957 5.70833 20 7.7 20 10.2C20 11.8 19.4 13.521 18.2 15.363C17 17.2043 15.1833 19.2 12.75 21.35C12.65 21.4333 12.5333 21.5 12.4 21.55C12.2667 21.6 12.1333 21.625 12 21.625Z"
          fill="#CCCFD6"
        />
      </g>
    </svg>
  )
}

export default Location
